import React, { useContext } from 'react'
import Iframe from 'react-iframe'

import { Paper } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'

import DefaultModal from '../atoms/DefaultModal'
import ConfigContext from '../../ConfigContext'
import appTopPage from '../../assets/image/iphonex_top.png'
import { mainColor } from '../../OverrideMUITheme'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(4)
  },
  paper2: {
    padding: theme.spacing(4),
    overflow: 'auto',
    width: 450,
    height: '90vh'
  },
  frame2: {
    position: 'relative',
    width: '320px',
    height: '62vh',
    maxHeight: '568px',
    minHeight: '400px'
  },
  frame3: {
    position: 'relative',
    height: '815px'
  },
  webView: {
    backgroundColor: 'white',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    borderColor: '#C1C1C1',
    borderStyle: 'solid'
  },
  webViewTop: {
    backgroundColor: 'white',
    position: 'absolute',
    top: '91px',
    left: '3px',
    border: 'none',
    boxSizing: 'content-box'
  },
  appTopPage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '375px',
    height: '812px',
    borderColor: '#C1C1C1',
    borderStyle: 'solid',
    borderWidth: '3px',
    boxSizing: 'content-box'
  },
  bullets: {
    position: 'absolute',
    top: '317px',
    left: '3px',
    width: '375px',
    height: '257px',
    textAlign: 'center'
  },
  bullet: {
    width: '10px',
    height: '10px',
    display: 'inline-block',
    borderRadius: '100%',
    background: '#000',
    opacity: '0.2',
    color: '#000',
    margin: '0 10px'
  },
  bulletActive: {
    width: '10px',
    height: '10px',
    display: 'inline-block',
    borderRadius: '100%',
    background: mainColor,
    color: mainColor,
    margin: '0 10px'
  }
}))

const CreateMessagePaper: React.FC<{
  isOpen: boolean
  handleClose: () => void
  url: string
  appliTopPage?: boolean
}> = ({ isOpen, handleClose, url, appliTopPage }) => {
  const classes = useStyles({})
  const config = useContext(ConfigContext)
  console.log(url)
  return (
    <React.Fragment>
      <DefaultModal open={isOpen} onClose={() => handleClose()}>
        {isOpen &&
          (config.enableBannerPreview === '1' && appliTopPage ? (
            <Paper className={classes.paper2}>
              <div className={classes.frame3}>
                <img src={appTopPage} alt={'top page'} className={classes.appTopPage} />
                <Iframe
                  url={url}
                  width="375px"
                  height="257px"
                  display="block"
                  className={classes.webViewTop}
                />
                <div className={classes.bullets}>
                  <span className={classes.bulletActive}></span>
                  <span className={classes.bullet}></span>
                  <span className={classes.bullet}></span>
                </div>
              </div>
            </Paper>
          ) : (
            <Paper className={classes.paper}>
              <div className={classes.frame2}>
                <Iframe
                  url={url}
                  width="320px"
                  height="568px"
                  display="block"
                  className={classes.webView}
                />
              </div>
            </Paper>
          ))}
      </DefaultModal>
    </React.Fragment>
  )
}

export default CreateMessagePaper
